import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import $t from 'locales/en/translation';
import HomeLoanInfoCard from '../components/HomeLoanInfoCard';
import { Image } from 'components/Image/Image';
import '../components/HomeLoanInfoCard.scss';
import OText from 'components/CText/OText';

const AboutRefinanceModuleView = props => {
  return (
    <SectionContainer>
      <Row>
        <Label
          datatestid={`${props.datatestid}-needToKnowRefinance-title`}
          type="H3"
          typeHeader={'h3'}
          className="margB40"
        >
          About Refinance
        </Label>
        <HomeLoanInfoCard
          title={$t.reduceMonthlyPayment}
          detail={
            <OText
              text={props?.config?.home_loan?.about_refinance?.monthly_mortgage}
            />
          }
          classname="lowerinterestrateIcon"
          datatestid={`${props.datatestid}-reduceMP`}
        />
        <div className="margB40" />
        <HomeLoanInfoCard
          title={$t.cashOutRefinance}
          detail={props?.config?.home_loan?.about_refinance?.cash_out_refinance}
          classname="cashoutrefinanceIcon"
          datatestid={`${props.datatestid}-cashOut`}
        />
        {props?.config?.home_loan?.about_refinance?.cash_out_refinance
          ?.showRefinanceImage && (
          <div className="margR32 m-text-center m-margT24 homeLoanIndoCard d-hide">
            <Image imgClass="homelenderIcon bgImageWH56" />
          </div>
        )}
      </Row>
    </SectionContainer>
  );
};

export default AboutRefinanceModuleView;
